export default __webpack_public_path__ + "static/media/beep.5658e75a.wav";